import React, { memo } from 'react';
import propTypes from 'prop-types';
import { Columns, Column } from 'src/ui/mui-ui-kit';
import { Field } from 'react-final-form';
import { cleanseInt, cleanseDecimal } from 'src/ui/util';
import { UiInputAdapter, UiFieldset } from 'src/ui';

function LoanFinancialsForm({ className, form }) {
  return (
    <UiFieldset title="Financials" isFirst className={className}>
      <Columns isMultiline>
        <Column isSize="1/3" className="is-one-third-fullhd">
          <Field
            component={UiInputAdapter}
            name="loanAnnualSales"
            id="loanAnnualSales"
            label="Annual Sales $"
            onChange={e => form.mutators.cleanse(e, cleanseDecimal)}
          />
        </Column>
        <Column isSize="1/3" className="is-one-third-fullhd">
          <Field
            component={UiInputAdapter}
            name="loanBuisnessNetIncome"
            id="loanBuisnessNetIncome"
            label="Buisness Net Income $"
            onChange={e => form.mutators.cleanse(e, cleanseDecimal)}
          />
        </Column>
        <Column isSize="1/3" className="is-one-third-fullhd">
          <Field
            component={UiInputAdapter}
            name="loanBusinessNetEquity"
            id="loanBusinessNetEquity"
            label="Business Net Equity $"
            onChange={e => form.mutators.cleanse(e, cleanseDecimal)}
          />
        </Column>
        <Column isSize="1/3" className="is-one-third-fullhd">
          <Field
            component={UiInputAdapter}
            name="loanNumberOfEmployees"
            id="loanNumberOfEmployees"
            label="Number Of Employees"
            onChange={e => form.mutators.cleanse(e, cleanseInt)}
          />
        </Column>
        <Column isSize="1/3" className="is-one-third-fullhd">
          <Field
            component={UiInputAdapter}
            name="loanAutomaticPaymentChecking"
            id="loanAutomaticPaymentChecking"
            label="Business Checking Account #"
          />
        </Column>
      </Columns>
    </UiFieldset>
  );
}

LoanFinancialsForm.defaultProps = {
  className: '',
};

LoanFinancialsForm.propTypes = {
  className: propTypes.string,
  form: propTypes.object.isRequired,
};

const memoizedLoanFinancialsForm = memo(LoanFinancialsForm);

export { memoizedLoanFinancialsForm as LoanFinancialsForm };
